import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import {
    DeleteStories,
    GetStoriesList,
    UpdateStories,
    VerifyStories
} from '../../redux/Stories/actions';
import { connect, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import moment from 'moment';
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles } from '@material-ui/core/styles';
import { RootState } from '../../redux/store';
import { Chip, Tab, Table, Tabs, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useCookies } from 'react-cookie';
import { Route, useHistory, useLocation } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Routes } from '../../constants';
import { CommonDispatcher, OpenModal } from '../../redux/Common/action';
import {
    OPEN_ALERT_MODAL,
    TOGGLE_CHANGE_OWNERSHIP_MODAL
} from '../../redux/ModalReducer/actionTypes';
import { SHOW_SNACKBAR } from '../../redux/Common/actionTypes';
import { getQuery, goToListing } from '../../utils/common';
import TableHeaderFilter from '../Common/TableHeaderFilter';
import { showSnackbar } from '../../utils/snackbar';
import { useTenant } from '../../utils/tenant';
import NewsCategories from '../NewsCategories';

const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%'
    },
    container: {
        maxHeight: 'calc( 100vh - 120px)',
        minHeight: 'calc( 100vh - 120px)'
    }
});

const options = [
    { title: 'Edit', value: 'edit' },
    { title: 'Go to details page', value: 'redirectToListings' },
    { title: 'Change ownership', value: 'changeOwnership' },
    { title: 'Delete', value: 'delete' }
];

const Stories = ({
    GetStoriesList,
    VerifyStories,
    UpdateStories,
    OpenModal,
    CommonDispatcher,
    DeleteStories
}) => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedUser, setSelectedUser] = useState({});
    const tableHeader = useSelector(
        (store: RootState) => store?.stories.tableHeader || []
    );
    const listingsData = useSelector(
        (store: RootState) => store?.stories.listingsData
    );
    const categories =
        useSelector(
            (store: RootState) => store?.commonAppData.categories?.stories
        ) || [];
    const [page, setPage] = useState((listingsData?.current_page || 1) - 1);
    const rowsPerPage = 30;
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [cookies] = useCookies(['pgAdminToken']);
    const token = cookies['pgAdminToken'];
    const { client } = useTenant();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>, user) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedUser(user);
    };

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const query = getQuery(history);
    const keyword = query.get('keyword') || '';
    const page_number = Number(query.get('page')) || 1;
    const isNewsCategoriesRoute = location.pathname === Routes.storyCategories;

    useEffect(() => {
        setSelectedTab(isNewsCategoriesRoute ? 1 : 0);
        if (!isNewsCategoriesRoute) {
            getData({ keyword, page_number });
        }
        // eslint-disable-next-line
    }, [keyword, page_number, isNewsCategoriesRoute]);

    const getData = (data) => {
        setIsLoading(true);
        GetStoriesList(token, data).then(() => {
            setIsLoading(false);
        });
    };

    const appendPageNumber = (pageNumber) => {
        history.push({
            pathname: Routes.stories,
            search: `?page=${pageNumber}`
        });
    };

    const renderStories = () => {
        GetStoriesList(token, listingsData?.current_page).then(() => {
            OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                isOpen: false,
                isLoading: false
            });
            CommonDispatcher(SHOW_SNACKBAR, {
                isShowing: true,
                message: 'Ownership changed successfully'
            });
        });
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        appendPageNumber(newPage + 1);
    };

    const handleTabChange = (_event: React.ChangeEvent<{}>, value: number) => {
        setSelectedTab(value);
        history.push(value === 1 ? Routes.storyCategories : Routes.stories);
    };

    const handleChange = (value, selectedUser) => {
        switch (value) {
            case 'edit':
                history.push(
                    `/edit${Routes.stories}/${selectedUser?.story_id}`
                );
                break;
            case 'redirectToListings':
                goToListing(
                    Routes.stories,
                    categories,
                    selectedUser?.category_id,
                    selectedUser?.story_id,
                    client
                );
                break;
            case 'verify':
                OpenModal(OPEN_ALERT_MODAL, {
                    isOpen: true,
                    title: 'Post Story Live',
                    description: 'Are you sure you want to post this live?',
                    submitTitle: 'Post Live',
                    isDelete: false,
                    data: { disableBackdropClick: true },
                    callBack: () => {
                        VerifyStories(token, selectedUser)
                            .then(() => {
                                OpenModal(OPEN_ALERT_MODAL, {
                                    isOpen: false
                                });
                                getData({ page });
                            })
                            .catch(() => {
                                OpenModal(OPEN_ALERT_MODAL, {
                                    isOpen: false
                                });
                                showSnackbar('Something went wrong.');
                            });
                    }
                });
                break;
            case 'changeOwnership':
                OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                    isOpen: true,
                    title: 'Change ownership',
                    submitTitle: 'Change',
                    data: {
                        modalSize: 'xs',
                        disableBackdropClick: true,
                        owner_email: selectedUser?.owner_email
                    },
                    callBack: (flag, user_id) => {
                        if (flag) {
                            OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                                isOpen: true,
                                isLoading: true,
                                title: 'Change ownership',
                                submitTitle: 'Change',
                                data: {
                                    modalSize: 'xs',
                                    disableBackdropClick: true,
                                    owner_email: selectedUser?.owner_email
                                }
                            });
                            UpdateStories(token, {
                                story_id: selectedUser?.story_id,
                                user_id
                            })
                                .then((d) => {
                                    if (d?.type === 'success') {
                                        renderStories();
                                    } else if (d?.type === 'failed') {
                                        OpenModal(
                                            TOGGLE_CHANGE_OWNERSHIP_MODAL,
                                            {
                                                isOpen: true,
                                                isLoading: false
                                            }
                                        );
                                        CommonDispatcher(SHOW_SNACKBAR, {
                                            isShowing: true,
                                            message:
                                                'Failed to change ownership'
                                        });
                                    }
                                })
                                .catch(() => {
                                    OpenModal(TOGGLE_CHANGE_OWNERSHIP_MODAL, {
                                        isOpen: false,
                                        isLoading: false
                                    });
                                    CommonDispatcher(SHOW_SNACKBAR, {
                                        isShowing: true,
                                        message: 'Failed to change ownership'
                                    });
                                });
                        }
                    }
                });
                break;
            case 'delete':
                OpenModal(OPEN_ALERT_MODAL, {
                    isOpen: true,
                    title: 'Delete Story',
                    description: 'Are you sure you want to delete this post?',
                    submitTitle: 'Delete',
                    isDelete: true,
                    data: { disableBackdropClick: true },
                    callBack: () => {
                        DeleteStories(token, selectedUser?.story_id)
                            .then(() => {
                                OpenModal(OPEN_ALERT_MODAL, {
                                    isOpen: false
                                });
                                getData({ page });
                            })
                            .catch(() => {
                                OpenModal(OPEN_ALERT_MODAL, {
                                    isOpen: false
                                });
                                showSnackbar('Something went wrong.');
                            });
                    }
                });
                break;
        }
    };

    const renderMenu = ({ story_id, owner_email, category_id }) => {
        return (
            <>
                <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={(e) =>
                        handleClick(e, { story_id, owner_email, category_id })
                    }
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    elevation={0}
                    PaperProps={{
                        style: {
                            // maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                            border: '1px solid rgb(0 106 194 / 20%)'
                        }
                    }}
                >
                    {options.map((option, i) => (
                        <MenuItem
                            key={option?.value}
                            onClick={() => {
                                handleChange(option?.value, selectedUser);
                                setAnchorEl(null);
                            }}
                        >
                            {option?.title}
                        </MenuItem>
                    ))}
                </Menu>
            </>
        );
    };

    return (
        <Grid container spacing={0} className="h-100">
            <Grid item xs={12}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    classes={{
                        flexContainer: !isSmallScreen
                            ? 'justify-content-center'
                            : ''
                    }}
                >
                    <Tab
                        label="All"
                        className="text-inherit"
                        disableRipple={true}
                        disableFocusRipple={true}
                    />
                    <Tab
                        label="News Categories"
                        className="text-inherit"
                        disableRipple={true}
                        disableFocusRipple={true}
                    />
                </Tabs>
                <Paper className={classes.root}>
                    <Route
                        path={Routes.stories}
                        exact
                        render={() => (
                            <>
                                <TableHeaderFilter
                                    sectionBaseUrl={Routes.stories}
                                />
                                {isLoading ? (
                                    <div className="mainLoader">
                                        <div className="loader" />
                                    </div>
                                ) : (
                                    <>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {tableHeader?.map((column) => (
                                                <TableCell key={column.id}>
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listingsData?.posts.length ? (
                                            listingsData?.posts?.map((row) => {
                                                const color = [
                                                    'LIVE',
                                                    'VERIFIED'
                                                ].includes(row.status)
                                                    ? '#319401'
                                                    : '#ff0000';
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row?.story_id}
                                                        style={{
                                                            padding: 0,
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={(e) => {
                                                            history.push(
                                                                `${Routes.stories}/${row?.story_id}`
                                                            );
                                                        }}
                                                    >
                                                        <TableCell
                                                            size={'small'}
                                                            onClick={(e) =>
                                                                e.stopPropagation()
                                                            }
                                                        >
                                                            {renderMenu(row)}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                color,
                                                                minWidth:
                                                                    '100px'
                                                            }}
                                                            size={'small'}
                                                        >
                                                            {moment(
                                                                row?.createdAt
                                                            ).format(
                                                                'DD MMM, YYYY'
                                                            )}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{ color }}
                                                            size={'small'}
                                                        >
                                                            {row?.status}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{ color }}
                                                            size={'small'}
                                                            onClick={(e) =>
                                                                e.stopPropagation()
                                                            }
                                                        >
                                                            <Chip
                                                                size="small"
                                                                label={
                                                                    row?.status ===
                                                                    'LIVE'
                                                                        ? 'Deactivate'
                                                                        : 'Activate'
                                                                }
                                                                clickable
                                                                color={
                                                                    row?.status ===
                                                                    'LIVE'
                                                                        ? 'secondary'
                                                                        : 'primary'
                                                                }
                                                                onClick={() => {
                                                                    handleChange(
                                                                        row?.status !==
                                                                            'LIVE'
                                                                            ? 'verify'
                                                                            : '',
                                                                        row?.story_id
                                                                    );
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                color,
                                                                minWidth:
                                                                    '100px'
                                                            }}
                                                            size={'small'}
                                                        >
                                                            {row?.expiry_date
                                                                ? moment(
                                                                      row?.expiry_date
                                                                  ).format(
                                                                      'DD MMM, YYYY'
                                                                  )
                                                                : 'N/A'}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{ color }}
                                                            size={'small'}
                                                        >
                                                            {row?.type}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{ color }}
                                                            size={'small'}
                                                        >
                                                            {row?.title}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{ color }}
                                                            size={'small'}
                                                        >
                                                            {row?.views}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{ color }}
                                                            size={'small'}
                                                        >
                                                            {row?.owner_name}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{ color }}
                                                            size={'small'}
                                                        >
                                                            {row?.owner_email}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={
                                                        tableHeader.length + 1
                                                    }
                                                    className="dataNotAvailable"
                                                >
                                                    Data not available
                                                </td>
                                            </tr>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                hidden={!listingsData?.posts.length}
                                rowsPerPageOptions={[]}
                                component="div"
                                count={listingsData?.count}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                            />
                                    </>
                                )}
                            </>
                        )}
                    />
                    <Route
                        path={Routes.storyCategories}
                        exact
                        render={() => <NewsCategories />}
                    />
                </Paper>
            </Grid>
        </Grid>
    );
};
export default connect(null, {
    GetStoriesList,
    VerifyStories,
    UpdateStories,
    DeleteStories,
    OpenModal,
    CommonDispatcher
})(Stories);
